import {Pipe} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {translatedString} from '../../interfaces/forms/form-element';

@Pipe({
  name: 'translate',
  standalone: false,
})
export class CustomTranslatePipe extends TranslatePipe {
  override transform(value: translatedString, params?: Record<string, unknown>): string {
    if (!value) return value;
    const text = typeof value === 'string' ? value : value.text;
    const obj = params ?? (typeof value === 'object' ? value.params : {});
    const translated = super.transform(text, obj);
    return translated.length > 0 ? translated : text;
  }
}
